import React, { forwardRef, useImperativeHandle } from 'react'
import Api from '../../../../_helpers/Api'
import axios from 'axios'
import { useEffect, useRef, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import Question from '../../../modals/messages/Question'
import AddOrEdit from './AddOrEdit'
import NoDataFound from '../../../partials/NoDataFound'
import Options from './Options'
import { trans } from '../../../../_providers/Translation'
import { useHistory, useLocation } from 'react-router'
import { contractorScopeConfig } from '../../../../_helpers/contractorScope'

function Index(props, ref) {
    const history = useHistory()
    const location = useLocation()

    const modalRef = useRef(null)
    const deleteModalRef = useRef(null)
    const searchTimeoutRef = useRef(null)

    const searchParams = new URLSearchParams(location.search)
    const cancelTokenRef = useRef(null)

    const [data, setData] = useState({
        loading: true,
        data: [],
        filters: {
            name: '',
        },
        setFilter: false,
        update: false,
    })

    useImperativeHandle(ref, () => ({
        add: () => {
            handleAdd()
        }
    }))

    useEffect(() => {
        setData(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                name: searchParams.get('name') || '',
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    useEffect(() => {
        if (data.setFilter) {
            Object.entries(data.filters).map(filter => {
                searchParams.set(filter[0], filter[1])
            })

            history.push('?' + searchParams.toString())
        }
    }, [data.setFilter])

    useEffect(() => {
        if (data.update) {
            loadTypes()
        }
    }, [data.update])

    const loadTypes = () => {
        // Cancel previous request if running
        if (cancelTokenRef.current) {
            cancelTokenRef.current.cancel('Operation canceled due to new request.')
        }
        cancelTokenRef.current = axios.CancelToken.source()

        setData(prev => ({
            ...prev,
            loading: true
        }))

        let url = `contractors/types?name=${data.filters.name}`

        Api.get(url, { cancelToken: cancelTokenRef.current.token, ...contractorScopeConfig() })
            .then(res => {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data
                }))
            }).catch(err => {
                if (!axios.isCancel(err)) {
                    setData(prev => ({
                        ...prev,
                        loading: false
                    }))
                }
            })
    }

    // create
    const handleAdd = () => {
        modalRef.current.add()
    }

    const handleCreate = () => {
        setData(prev => ({
            ...prev,
            update: Math.random().toString()
        }))
    }

    // update
    const handleEdit = id => {
        modalRef.current.edit(id)
    }

    const handleUpdate = row => {

        let updated = data.data.map(i => {
            if (i.id == row.id) {
                i = row
            }
            return i
        })

        setData(prev => ({
            ...prev,
            data: updated,
        }))
    }

    // delete
    const handleDestroy = id => {

        let url = 'contractors/types/delete'

        Api.post(url, {
            id: id
        }).then(res => {
            if (res.data.success) {
                let filtered = data.data.filter(i => {
                    return i.id !== id
                })

                setData(prev => ({
                    ...prev,
                    data: filtered
                }))

                deleteModalRef.current.close()
            }
        })
    }

    // Question modal
    const handleDelete = id => {
        deleteModalRef.current.open(id)

        deleteModalRef.current.onSuccess(() => {
            handleDestroy(id)
        })
    }

    function handleSearch(name, value) {
        clearTimeout(searchTimeoutRef.current)

        setData(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                [name]: value
            },
        }))

        searchTimeoutRef.current = setTimeout(() => {
            setData(prev => ({
                ...prev,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }

    return (
        <>
            <AddOrEdit
                ref={modalRef}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
            />

            <Question
                ref={deleteModalRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
            />

            <div className='filter-standard'>
                <div className="col">
                    <input
                        type="search"
                        name="name"
                        onChange={(e) => handleSearch(e.target.name, e.target.value)}
                        value={data.filters.name}
                        placeholder={trans('labels.search')}
                    />
                </div>
            </div>
            <hr />
            {data.loading
                ?
                <Skeleton height={45} count={10} />
                :
                data.data.length === 0
                    ?
                    <NoDataFound />
                    :
                    <>
                        <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            {trans('tables.type')}
                                        </th>
                                        <th className="options">
                                            {trans('tables.options')}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.data.map(t =>
                                        <tr key={t.id}>
                                            <td>{t.translation?.name || t.name}</td>
                                            <td className="options">
                                                {t.allow_edit &&
                                                    <Options
                                                        id={t.id}
                                                        data={t}
                                                        handleEdit={handleEdit}
                                                        handleDelete={handleDelete}
                                                    />
                                                }
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </>
            }

        </>
    )
}

export default forwardRef(Index)